import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { inv2022 } from "../../utils";
import "../Css/inv.css";
export default function Tax() {
  const { id, year } = useParams();
  const [invdata, setInvdata] = useState({});
  useEffect(() => {
    axios
      .get(`${inv2022}/${id}/taxinvoicenew/${year}`)
      .then((res) => {
        setInvdata(res.data);

        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "15px",
          marginBottom: "650px",
        }}
        className="onepage"
      >
        <div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div>
                <img src="/incometax.png" alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // paddingLeft: "100px",
                  fontSize: "14px",
                  gap: "10px",
                }}
              >
                <div style={{ textDecoration: "underline" }}>
                  Office of TDS CIRCLE-3(1), BANGALORE
                </div>
                <div style={{ textDecoration: "underline" }}>
                  HMT BUILDING, BANGALORE
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "40px",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", gap: "3px" }}>
            <div>Ref No. :</div>
            <div>197(1)/AAWCS4663E/2023-24/1</div>
          </div>
          <div style={{ display: "flex", gap: "3px" }}>
            <div>DATE :</div>
            <div>19-Jun-2023</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            marginTop: "20px",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", gap: "3px" }}>
            <div> Subject:</div>
            <div>Certificate u/s 197 for PAN :</div>
            <div>AAWCS4663E</div>
          </div>
        </div>
        <p style={{ fontSize: "10px" }}>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;Deductor(s) with TAN/PAN (as per column 3) is/are hereby
          authorized to make payment or credit the amount under section (as per
          column 5 of the table below) to the extent (as per column 7) after
          deducting tax at the rate (as per column 8, excluding education cess/
          Surcharge as applicable) to, or as the case may be to the account of
          STELLARSLOG TECHNOVATION PRIVATE LIMITED, No. 33, Mohan chambers, 1st
          Main Road, JP Nagar 3rd Phase, Bengaluru, KARNATAKA, Pincode- 560078
          (PAN-AAWCS4663E). As per details below:
        </p>
        <br />
        <div>
          <table>
            <tr>
              <th>Sr.No. </th>
              <th>Certificate Number</th>
              <th>TAN/PAN </th>
              <th>TAN/PAN Name </th>
              <th>Section </th>
              <th>Nature of payment </th>
              <th>Amount (Rs.)</th>
              <th>Certificate Rate (%)</th>
              <th>Valid from Date </th>
              <th>Valid till date </th>
            </tr>
            <tr>
              <td>1</td>
              <td>{invdata?.client?.certificate_number}</td>
              <td>{invdata?.client?.gstno?.split("").splice(2, 10)}</td>
              <td>{invdata?.client?.companyname}</td>
              <td>
                {invdata?.invoice?.tds_per == "1"
                  ? "194J"
                  : invdata?.invoice?.tds_per == "0.25"
                  ? "194C"
                  : "--"}
              </td>
              <td>
                {invdata?.invoice?.tds_per == "1"
                  ? "Fees for professional services & others"
                  : invdata?.invoice?.tds_per == "0.25"
                  ? "Payments to contractors"
                  : "--"}
              </td>
              <td>{invdata?.client?.tds_est_amt}</td>
              <td>{invdata?.invoice?.tds_per}</td>
              <td>19-Jun-2023</td>
              <td>31-Mar-2024</td>
            </tr>
          </table>
        </div>
        <br />
        <p>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Certificate(s)
          is/are non-transferable and valid for applicant PAN -AAWCS4663E for
          sums which are to be received or receivable, whichever is earlier
          between the period as per column 9 and 10, unless it is cancelled by
          the undersigned under intimation to respective TAN(s)/ PAN(s) before
          that date.
        </p>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "flex-end",
          }}
        >
          <div>REHNA R</div>
          <div>TDS CIRCLE-3(1), BANGALORE</div>
        </div>
        <br />
        <div
          style={{ display: "flex", width: "100%", justifyContent: "center" }}
        >
          *******This is an electronically generated certificate, therefore does
          not require any signature*******
        </div>
        <div>
          <b>Disclaimer</b>: The Notice/Letter/Order/Request No./Communication
          Reference No. mentioned above may be treated as DIN for the purpose of
          procedure for issuance of Notice/Letter/Order/Summons/ Correspondence
          prescribed by Circular No. 19 /2019 dated August 14, 2019.
        </div>
      </div>
      <div className="invdEtaModal">
        <div className="inv_contain">
          <span className="tax_head">Tax Invoice</span>
          <div className="mt-3 d-flex justify-content-between">
            <img
              src={window.location.origin + "/images/taskmo_new.png"}
              alt="ott"
              className="logo_left_css"
            />
            <div className="date_data_css">
              <span className="right_tax_css">
                #TMB/
                {year == "2023"
                  ? "23-24"
                  : year == "2022"
                  ? "22-23"
                  : year == "2021"
                  ? "21-22"
                  : "20-21"}
                /
                {invdata?.invoice?.invoice_number <= "99" &&
                invdata?.invoice?.invoice_number >= "1"
                  ? `0${invdata?.invoice?.invoice_number}`
                  : invdata?.invoice?.invoice_number <= "999" &&
                    invdata?.invoice?.invoice_number >= "100"
                  ? `0${invdata?.invoice?.invoice_number}`
                  : invdata?.invoice?.invoice_number}
              </span>
              <span className="right_tax_css">
                Date:{" "}
                {moment(invdata?.invoice?.created_on).format("DD-MM-YYYY")}
              </span>
              {invdata?.invoice?.po_date == "0000-00-00" ? (
                <></>
              ) : (
                <>
                  <span className="right_tax_css">
                    PO NO:
                    {invdata?.invoice?.po_no}
                  </span>
                  <span className="right_tax_css">
                    PO Date:
                    {moment(invdata?.invoice?.po_date).format("DD-MM-YYYY")}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="d-flex flex-column">
            <span className="head_bill_css">Bill To</span>
            <span className="legal_name_css">
              {invdata?.client?.companyname}
            </span>
            <div className="legal_name_css1">
              {invdata?.client?.billing_address}
            </div>
            <div className="d-flex align-items-end">
              <span className="head_bill_css mt-1">GSTIN : </span>
              <span className="legal_name_css">{invdata?.client?.gstno}</span>
            </div>
            <div className="d-flex align-items-end">
              <span className="head_bill_css">Place of Supply : </span>
              <span className="legal_name_css">{invdata?.client?.state}</span>
            </div>
          </div>
          <table class="table table-bordered my-3" style={{ width: "100%" }}>
            <thead class="bg-gray-200">
              <tr>
                <th scope="col" style={{ width: "50%" }}>
                  <b
                    className="float-left"
                    style={{ fontSize: "15px", fontWeight: 700 }}
                  >
                    Description
                  </b>
                </th>
                <th style={{ width: "10%" }}>
                  <b
                    class="float-right"
                    style={{ fontSize: "15px", fontWeight: 700 }}
                  >
                    HSN/SAC
                  </b>
                </th>
                <th style={{ width: "10%" }}>
                  <b
                    class="float-right"
                    style={{ fontSize: "15px", fontWeight: 700 }}
                  >
                    Quantity
                  </b>
                </th>
                <th style={{ width: "10%" }}>
                  <b
                    class="float-right"
                    style={{ fontSize: "15px", fontWeight: 700 }}
                  >
                    Cost
                  </b>
                </th>
                <th style={{ width: "15%" }}>
                  <b
                    class="float-right"
                    style={{ fontSize: "15px", fontWeight: 700 }}
                  >
                    Amount (Rs.)
                  </b>
                </th>
              </tr>
            </thead>
            <tbody>
              {invdata?.desc?.map((res) => {
                return (
                  <tr>
                    <td
                      style={{
                        verticalAlign: "bottom !important",
                        width: "55%",
                      }}
                      className="desc_box_css"
                    >
                      <h1 class="text-dark">
                        <b
                          style={{
                            marginBottom: "5px",
                            fontSize: "16px",
                            fontWeight: 600,
                            display: "flex",
                          }}
                        >
                          {res.description}
                        </b>
                      </h1>
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        width: "10%",
                      }}
                    >
                      <b
                        class="float-right"
                        style={{ fontSize: "16px", textAlign: "center" }}
                      >
                        {res.hsn}
                      </b>
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        width: "10%",
                      }}
                    >
                      <b
                        class="float-right"
                        style={{ fontSize: "16px", textAlign: "center" }}
                      >
                        {res.quantity}
                      </b>
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        width: "10%",
                      }}
                    >
                      <b
                        class="float-right"
                        style={{ fontSize: "16px", textAlign: "center" }}
                      >
                        {res.cost}
                      </b>
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        width: "15%",
                      }}
                    >
                      <b
                        class="float-right"
                        style={{ fontSize: "16px", textAlign: "center" }}
                      >
                        {res.amount}
                      </b>
                    </td>
                  </tr>
                );
              })}

              <tr class="bg-gray-100">
                <td colSpan={4}>
                  <b
                    style={{ marginBottom: "5px", fontSize: "14px" }}
                    class="float-right"
                  >
                    Sub Total
                  </b>
                </td>
                <td style={{ textAlign: "right" }}>
                  <b
                    style={{ marginBottom: "5px", fontSize: "14px" }}
                    class="float-right"
                  >
                    {invdata?.invoice?.amount}
                  </b>
                </td>
              </tr>

              {invdata?.client?.state === "Karnataka (KA)" ? (
                <>
                  <tr>
                    <td colSpan={4}>
                      <b
                        style={{ marginBottom: "5px", fontSize: "14px" }}
                        class="float-right"
                      >
                        CGST (9%)
                      </b>
                    </td>
                    <td>
                      <b
                        style={{ marginBottom: "5px", fontSize: "14px" }}
                        class="float-right"
                      >
                        {invdata?.cgst}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      <b
                        style={{ marginBottom: "5px", fontSize: "14px" }}
                        class="float-right"
                      >
                        SGST (9%)
                      </b>
                    </td>
                    <td>
                      <b
                        style={{ marginBottom: "5px", fontSize: "14px" }}
                        class="float-right"
                      >
                        {invdata?.sgst}
                      </b>
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={4}>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      IGST (18%)
                    </b>
                  </td>
                  <td>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      {invdata?.igst}
                    </b>
                  </td>
                </tr>
              )}

              <tr class="bg-gray-100">
                <td colSpan={4}>
                  <b
                    style={{ marginBottom: "5px", fontSize: "14px" }}
                    class="float-right"
                  >
                    Total Amount
                  </b>
                </td>
                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <b
                    style={{ marginBottom: "5px", fontSize: "16px" }}
                    class="float-right"
                  >
                    {invdata.totalAmount}
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="5" class="text-center">
                  <b
                    style={{
                      marginBottom: "5px",
                      fontSize: "15px",
                      float: "right",
                    }}
                    class="float-right; "
                  >
                    Amount In Words : {invdata?.amount_in_words} only
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ paddingBottom: "15px" }}>
            <div class="invoice-summary">
              <span>
                <img
                  src={window.location.origin + "/images/Seal.png"}
                  alt=""
                  width="200"
                  border="0"
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    height: "auto",
                    marginTop: "5px",
                    float: "right",
                  }}
                />
              </span>
            </div>
          </div>
          <div style={{ marginTop: "350px" }}>
            <table
              class="table mb-4"
              style={{
                display: "flex",
                justifyContent: "left",
                textAlign: "left",
                width: "100vw",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: "100%", borderTop: "none" }}>
                    <h4 class="font-weight-bold text-dark">Account Details:</h4>
                    <h4
                      class="text-dark"
                      style={{ fontSize: "20px", marginBottom: "0rem" }}
                    >
                      <span
                        style={{
                          fontWeight: 700,
                          fontStyle: "italic",
                          fontSize: "20px",
                        }}
                      >
                        Account Name :
                      </span>
                      &nbsp;
                      <span style={{ fontSize: "20px" }}>
                        STELLARSLOG TECHNOVATION PVT LTD
                      </span>
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontStyle: "italic",
                          fontSize: "20px",
                        }}
                      >
                        Bank Name :
                      </span>
                      &nbsp;
                      {new Date(invdata?.invoice?.created_on) >=
                      new Date("2023-01-16") ? (
                        <span style={{ fontSize: "20px" }}>HDFC Bank </span>
                      ) : (
                        <span style={{ fontSize: "20px" }}>Canara Bank</span>
                      )}
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontStyle: "italic",
                          fontSize: "20px",
                        }}
                      >
                        Account No. :
                      </span>
                      &nbsp;
                      {new Date(invdata?.invoice?.created_on) >=
                      new Date("2023-01-16") ? (
                        <span style={{ fontSize: "20px" }}>50200071637751</span>
                      ) : (
                        <span style={{ fontSize: "20px" }}>0414261017351</span>
                      )}
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontStyle: "italic",
                          fontSize: "20px",
                        }}
                      >
                        IFSC Code :
                      </span>
                      &nbsp;
                      {new Date(invdata?.invoice?.created_on) >=
                      new Date("2023-01-16") ? (
                        <span style={{ fontSize: "20px" }}>HDFC0002850</span>
                      ) : (
                        <span style={{ fontSize: "20px" }}>CNRB0000414</span>
                      )}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div style={{ textAlign: "center" }}>
              <p style={{ fontSize: "16px", marginBottom: "0rem" }}>
                <span className="footer-higlight">
                  STELLARSLOG TECHNOVATION PVT LTD
                </span>
                <br />
                Mohan Chambers, #31, 1st Main Road, 3rd Phase JP Nagar,
                Bangalore - 560078 <br />
                <span className="footer-higlight">
                  {" "}
                  GSTIN : 29AAWCS4663E1ZP{" "}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
